/** @jsxImportSource @emotion/react */

import React, { useState, useEffect } from "react";
import tw from "twin.macro";
import Planextlogo from "../Images/logo.png";

const Container = tw.div`bg-gray-200 items-center w-full justify-between flex py-2 md:px-20 px-6 `;

const HeaderLogoContainer = tw.div``;

export default () => {
  return (
    <Container>
      <a href="/">
        <HeaderLogoContainer>
          <img src={Planextlogo} width="80%" />
        </HeaderLogoContainer>
      </a>

      {/* <a href="http://www.goinstagood.com/">
        Visit <span tw=" font-semibold">InstaGood</span> Official Website
      </a> */}
    </Container>
  );
};
